import {FC} from 'react'
import {ErrorBoundary, FallbackProps} from 'react-error-boundary'

function ErrorFallback({error, resetErrorBoundary}: FallbackProps) {
  return (
    <div role='alert' className='alert alert-danger'>
      <h4>Something went wrong:</h4>
      <pre>{error.message}</pre>
      <button onClick={resetErrorBoundary} className='btn btn-primary'>
        Try again
      </button>
    </div>
  )
}

function refreshPage() {
  window.location.reload()
}

const ToolsPage: FC = () => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback} onReset={refreshPage}>
      <div
        className='ob-page'
        style={{
          paddingTop: 'var(--ob-spacing-6)',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          minHeight: 0,
        }}
      >
        {/* Header - matching other pages style */}
        <div className='card-header border-0 pt-5' style={{minHeight: '110px', flexShrink: 0}}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'start'}}>
            <h3>Tools</h3>
            <h5 style={{color: 'grey', alignContent: 'center'}}>
              Access bioinformatics tools and utilities
            </h5>
          </div>
        </div>

        {/* Tools Content */}
        <div
          className='ob-page__section'
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            minHeight: 0,
            gap: 'var(--ob-spacing-6)',
          }}
        >
          <div className='card'>
            <div className='card-body'>
              <div className='row'>
                <div className='col-md-6 col-lg-4 mb-4'>
                  <div className='card h-100 border-0 shadow-sm'>
                    <div className='card-body text-center'>
                      <div className='mb-3'>
                        <i className='fas fa-dna fa-3x text-primary'></i>
                      </div>
                      <h5 className='card-title'>Sequence Analysis</h5>
                      <p className='card-text text-muted'>
                        Analyze DNA and protein sequences with various bioinformatics tools.
                      </p>
                      <button className='btn btn-bioabm btn-sm'>Launch Tool</button>
                    </div>
                  </div>
                </div>

                <div className='col-md-6 col-lg-4 mb-4'>
                  <div className='card h-100 border-0 shadow-sm'>
                    <div className='card-body text-center'>
                      <div className='mb-3'>
                        <i className='fas fa-chart-line fa-3x text-success'></i>
                      </div>
                      <h5 className='card-title'>Expression Analysis</h5>
                      <p className='card-text text-muted'>
                        Analyze gene expression data and differential expression.
                      </p>
                      <button className='btn btn-success btn-sm'>Launch Tool</button>
                    </div>
                  </div>
                </div>

                <div className='col-md-6 col-lg-4 mb-4'>
                  <div className='card h-100 border-0 shadow-sm'>
                    <div className='card-body text-center'>
                      <div className='mb-3'>
                        <i className='fas fa-project-diagram fa-3x text-info'></i>
                      </div>
                      <h5 className='card-title'>Pathway Analysis</h5>
                      <p className='card-text text-muted'>
                        Explore biological pathways and network analysis.
                      </p>
                      <button className='btn btn-info btn-sm'>Launch Tool</button>
                    </div>
                  </div>
                </div>

                <div className='col-md-6 col-lg-4 mb-4'>
                  <div className='card h-100 border-0 shadow-sm'>
                    <div className='card-body text-center'>
                      <div className='mb-3'>
                        <i className='fas fa-microscope fa-3x text-warning'></i>
                      </div>
                      <h5 className='card-title'>Microbiome Analysis</h5>
                      <p className='card-text text-muted'>
                        Analyze microbial communities and metagenomic data.
                      </p>
                      <button className='btn btn-warning btn-sm'>Launch Tool</button>
                    </div>
                  </div>
                </div>

                <div className='col-md-6 col-lg-4 mb-4'>
                  <div className='card h-100 border-0 shadow-sm'>
                    <div className='card-body text-center'>
                      <div className='mb-3'>
                        <i className='fas fa-chart-pie fa-3x text-danger'></i>
                      </div>
                      <h5 className='card-title'>Statistical Analysis</h5>
                      <p className='card-text text-muted'>
                        Perform statistical tests and data visualization.
                      </p>
                      <button className='btn btn-danger btn-sm'>Launch Tool</button>
                    </div>
                  </div>
                </div>

                <div className='col-md-6 col-lg-4 mb-4'>
                  <div className='card h-100 border-0 shadow-sm'>
                    <div className='card-body text-center'>
                      <div className='mb-3'>
                        <i className='fas fa-cogs fa-3x text-secondary'></i>
                      </div>
                      <h5 className='card-title'>Data Processing</h5>
                      <p className='card-text text-muted'>
                        Clean, transform, and prepare data for analysis.
                      </p>
                      <button className='btn btn-secondary btn-sm'>Launch Tool</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Help text */}
        <div className='ob-page__section' style={{marginTop: '1rem', flexShrink: 0}}>
          <div className='alert alert-info' role='alert'>
            <i className='fas fa-info-circle me-2'></i>
            <strong>Tools Page:</strong> This page provides access to various bioinformatics tools
            and utilities. Click on any tool to launch it and start your analysis. Make sure you
            have the necessary data files ready before starting any analysis.
          </div>
        </div>
      </div>
    </ErrorBoundary>
  )
}

export default ToolsPage
